import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse'
import { getPayRateByLocationKey } from './keys'
import {
  PayRateByLocation,
  getPayRateByLocation,
} from 'api/pulse/payRateByLocation'
import { PULSE_QUERY_OPTIONS } from './constants'

export function usePayRateByLocation(query: PulsePaginatedFilters) {
  return useInfiniteQuery<PayRateByLocation>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getPayRateByLocationKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getPayRateByLocation(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
    refetchOnWindowFocus: false,
  })
}
